import { Sparkles } from 'lucide-react';
import { Modal } from './Modal';
import { CHANGELOG } from '@/lib/release-changelog';

type Props = {
  open: boolean;
  onClose: () => void;
};

/** v0.3 (S-17 Design-H4) 初回ログイン時のリリース通知モーダル。AppLayout から表示制御される。 */
export function ReleaseChangelogModal({ open, onClose }: Props) {
  return (
    <Modal
      open={open}
      title="新機能のお知らせ"
      onClose={onClose}
      size="sm"
      footer={(
        <button type="button" onClick={onClose}
          className="px-4 py-2 rounded bg-brand-red text-white hover:bg-brand-red-hover text-sm">
          閉じる
        </button>
      )}
    >
      <div className="space-y-4">
        {CHANGELOG.map((entry) => (
          <div key={entry.version}>
            <div className="flex items-center gap-2 mb-1">
              <Sparkles size={16} className="text-brand-red shrink-0" />
              <h3 className="font-semibold text-sm">{entry.title}</h3>
              <span className="text-xs text-neutral-sub tabular-nums ml-auto">{entry.version} ({entry.date})</span>
            </div>
            <ul className="list-disc pl-6 space-y-1 text-sm text-neutral-text">
              {entry.items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </Modal>
  );
}
